import type React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	url: string;
}>;

export const DesktopShareAssetHeader: React.FC<Props> = ({ url }) => {
	const { translate } = useI18n();

	return (
		<div className="relative -mb-4">
			<div
				data-qa="psf-share-desktop-asset-bg"
				/*
				 * bg color is --Gray-Gray-Slate-200.
				 * md:h-[19.57rem] matches PetitionMedia's desktop height so the page layout doesn't shift between petitions with vs without bestShareVisual.
				 */
				className="dark:bg-background-raised relative flex items-center justify-center rounded-t-xl bg-[#3a3e4933] pb-4 md:h-[19.57rem]"
			>
				<img src={url} alt={translate('corgi.psf.share.share_visual_preview_alt')} className="block w-80 rounded-lg" />
			</div>
		</div>
	);
};
